import React, { useEffect } from 'react';
import './AboutUs.css';
import teamImage from '../../assets/images/teamImage.jpg'; 

const AboutUs = () => {

 useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
        }
      });
    });

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach(el => observer.observe(el));
  }, []);

  return (
 <div className="aboutcard-us">
      <div className="aboutcard-header animate-on-scroll">
        <h2 className="aboutcard-title">
          <span className="aboutcard-corner top-left" />
          <span className="aboutcard-corner top-right" />
          Qui sommes nous ?
          <span className="aboutcard-corner bottom-left" />
          <span className="aboutcard-corner bottom-right" />
        </h2>
      </div>

      <h3 className="animate-on-scroll">Hoag Target Consulting -</h3>
      <h3 className="animate-on-scroll">Exporter les talents et produits malagasy</h3>

      <div className="aboutcard-section">
        <div className="aboutcard-card animate-on-scroll">
          <p>
            Hoag Target est un cabinet de conseil basé à Madagascar, spécialisé dans la transformation
            digitale, l’orientation professionnelle et l’insertion des talents sur le marché du travail.
          </p>
        </div>

        <div className="aboutcard-image-text">
          <img
            src={teamImage}
            alt="Team collaboration"
            className="aboutcard-team-image animate-on-scroll"
          />
          <div className="aboutcard-card aboutcard-right animate-on-scroll">
            <p>
              Notre nom s’inspire de la galaxie Hoag, un symbole fort d’expansion et de jeunesse. Il reflète
              notre ambition : mettre en valeur les talents malagasy et les produits Made in Madagascar en
              les connectant à des opportunités internationales.
            </p>
          </div>
        </div>

        <div className="aboutcard-card animate-on-scroll">
          <p>
            Nous accompagnons les jeunes, les entreprises et les institutions à réussir leur transition vers
            le digital, à se préparer aux métiers d’avenir et à accéder à des marchés compétitifs à l’échelle
            mondiale. Nos piliers : compétence, innovation et impact.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
